import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NonAllocatedSimResultModel } from '../../shared/models/sim-related/NonAllocatedSimResultModel';
import { NonAllocatedSimSearchParamModel } from '../../shared/models/sim-related/NonAllocatedSimSearchParamModel';
import { PreloaderHandler, DOTS_FULL } from '../../shared/preloader/preloader-handler';
import { NonAllocatedSimService } from './non-allocated-sim.service';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { PaginationOutputModel } from '../../pagination/pagination-models/pagination-output.model';
import { NonAllocatedSimModel } from '../../shared/models/sim-related/NonAllocatedSimModel';

@Component({
    selector: 'non-allocated-sim',
    templateUrl: 'non-allocated-sim.component.html'
})

export class NonAllocatedSimComponent {

    @Output() selectedSim = new EventEmitter();
    @Input() searchParams: NonAllocatedSimSearchParamModel;
    @Input() show = false;
    @Input() embedded = false;
    private nonAllocatedResult: NonAllocatedSimResultModel;
    private preloaderHandler: PreloaderHandler;

    constructor(private _nasService: NonAllocatedSimService,
        //private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, DOTS_FULL);
    }

    changePage(data: PaginationOutputModel): void {
        this.searchParams.skip = data.skipNum;
        this.getData();
    }

    refreshData(): void {
        this.getData();
    }

    updateSearch(params: NonAllocatedSimSearchParamModel) {
        this.searchParams = params;
        this.searchParams.skip = 0;
        this.nonAllocatedResult = null;
        this.getData();
    }

    private simSelected(sim: NonAllocatedSimModel): void {
        this.selectedSim.emit(sim);
    }

    private getData() {
        this.preloaderHandler.reset();
        this._nasService
            .GetNonAllocatedSim(this.searchParams)
            .subscribe(data => {
                this.nonAllocatedResult = data
            },
            error => {
                this.oidcSecurityService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded()
            });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/sims/non-allocated-sims/non-allocated-sim.component.ts